import React, { useState } from 'react';

export interface TabDef {
  id: string;
  heading?: React.ReactNode;
  label?: string;
  content: React.ReactNode;
  disabled?: boolean;
}

interface TabsProps {
  tabs: TabDef[];
  defaultTab?: string;
  activeTab?: string;
  onTabChange?: (id: string) => void;
  scrollContent?: boolean;
}

export function Tabs({ tabs, defaultTab, activeTab, onTabChange, scrollContent }: TabsProps) {
  const [internalId, setInternalId] = useState(defaultTab ?? tabs.find(t => !t.disabled)?.id ?? tabs[0]?.id);
  const activeId = activeTab ?? internalId;
  const setActiveId = (id: string) => { setInternalId(id); onTabChange?.(id); };
  const active = tabs.find(t => t.id === activeId) ?? tabs[0];

  return (
    <div style={scrollContent ? { display: 'flex', flexDirection: 'column', height: '100%' } : undefined}>
      <ul className="nav nav-tabs" style={scrollContent ? { flexShrink: 0 } : undefined}>
        {tabs.map(tab => (
          <li key={tab.id} className={[tab.id === active?.id ? 'active' : '', tab.disabled ? 'disabled' : ''].filter(Boolean).join(' ')}>
            <a
              role="tab"
              onClick={e => { e.preventDefault(); if (!tab.disabled) setActiveId(tab.id); }}
              aria-disabled={tab.disabled}
            >
              {tab.heading ?? tab.label}
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-content" style={scrollContent ? { flex: 1, overflowY: 'auto', minHeight: 0 } : undefined}>
        {active?.content}
      </div>
    </div>
  );
}
